import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { MatSelectChange } from '@angular/material/select'

import { IMood } from '../../../Interface/mood'
import { I18nService, LgType } from '../../../services/prod/i18n.service'
import { TracksService } from '../../../services/tracks.service'
import { FilterPropertyType, IdType } from '../../../types/filter.type'

@Component({
  selector: 'bmcore-mood-select',
  templateUrl: './bmcore-mood-select.component.html',
  styleUrls: ['./bmcore-mood-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreMoodSelectComponent implements OnInit {
  @Input() moodId: IdType
  @Output() filterTracksEvent = new EventEmitter<FilterPropertyType>()

  lg: LgType
  moods: IMood[] = []

  constructor(
    private i18nService: I18nService,
    private tracksService: TracksService
  ) {}

  ngOnInit(): void {
    this.lg = this.i18nService.getLanguageForPage()
    this.tracksService.Moods.subscribe(res => (this.moods = res))
  }

  filterTracksByMood(matEvent: MatSelectChange) {
    this.filterTracksEvent.emit({ title: 'mood', id: matEvent.value })
  }

  getMoods(): IMood[] {
    return this.moods
  }
}
